// extracted by mini-css-extract-plugin
export default {"alertContainer":"styles_alertContainer__oDUMg","dangerAlert":"styles_dangerAlert__3yUD+","infoAlert":"styles_infoAlert__KRZ+6"};